import { useState, useEffect } from "react";
import { Moon, Sun } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function Layout({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window === "undefined") return false;
    const storedPreference = window.localStorage.getItem("murthyz-theme");
    return storedPreference ? storedPreference === "dark" : false;
  });

  useEffect(() => {
    document.body.className = darkMode ? "dark" : "";
    if (typeof window !== "undefined") {
      window.localStorage.setItem("murthyz-theme", darkMode ? "dark" : "light");
    }
  }, [darkMode]);

  const navItems = [
    { label: "Home", to: "/" },
    { label: "Projects", to: "/projects" },
    { label: "Resume", to: "/resume" },
  ];

  return (
    <div
      className={`relative min-h-screen overflow-hidden transition-colors duration-700 ${
        darkMode ? "text-white" : "text-gray-900"
      }`}
    >
      {/* Background */}
      <div
        className="fixed inset-0 -z-20 transition-all duration-700 dynamic-gradient"
        style={{
          background: darkMode
            ? "linear-gradient(135deg, #0f172a, #0b1120, #155e75)"
            : "linear-gradient(135deg, #e0f2fe, #bae6fd, #a5f3fc)",
        }}
      />

      {/* Modern navigation */}
      <header className="fixed top-6 inset-x-0 z-30 px-6">
        <div className="mx-auto flex max-w-4xl justify-center">
          <nav className="flex items-center gap-6 rounded-full border border-white/40 bg-white/70 dark:border-white/20 dark:bg-white/5 backdrop-blur-2xl px-7 py-4 shadow-xl font-inter">
            <span className="text-base font-semibold tracking-tight text-slate-900/80 dark:text-white/80">
              Siddhanth Murthy
            </span>
            <div className="flex items-center gap-1 text-sm font-medium md:text-base">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      "rounded-full px-3 py-1.5 transition-all duration-200",
                      "hover:bg-white/30 hover:text-slate-900 dark:hover:bg-white/20 dark:hover:text-white",
                      isActive
                        ? "bg-white/60 text-slate-900 shadow-sm dark:bg-white/25 dark:text-white"
                        : "text-slate-900/80 dark:text-white/70",
                    ].join(" ")
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </div>
      </header>

      {/* Content with fade transition */}
      <div className="animate-fadeIn px-6 md:px-10 pt-32 pb-16">{children}</div>

      {/* Dark/light toggle */}
      <button
        onClick={() => setDarkMode(!darkMode)}
        className="fixed bottom-6 right-6 p-4 rounded-full backdrop-blur-2xl border border-white/30 bg-white/10 hover:bg-white/20 active:scale-95 transition-all shadow-lg"
      >
        {darkMode ? <Sun size={22} /> : <Moon size={22} />}
      </button>
    </div>
  );
}
